import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "@environments/environment";

import { ParamsService } from "@shared/Services/params.service";
import { joinDateRange } from "@shared/Utils/format-api-date.util";

import { Dropdown } from "@RGVSI/Shared/Types/Enums/dropdown.enum";
import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";
import { VIN } from "@RGVSI/Shared/Types/Interfaces/vin.interface";

import { RenewVehicleFilter } from "../Types/Interfaces/renew-vehicle-filter.interface";
import { RenewVehicle, RenewVehicleResponse } from "../Types/Interfaces/renew-vehicle.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class RenewVehicleRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getStatus(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/Common/Dropdown/${Dropdown.VehicleStatus}`);
  }

  public getChassis(policy: string): Observable<VIN[]> {
    const params = this.paramsService.mapRequestParams({ policy });
    return this.http.get<VIN[]>(`${enlineaBackendUrl}/api/insurances/Certificates/Vehicles`, { params });
  }

  public getVehicle(vehicleFilter: RenewVehicleFilter): Observable<RenewVehicle[]> {
    const params = this.paramsService.mapRequestParams(vehicleFilter);
    return this.http.get<RenewVehicle[]>(`${enlineaBackendUrl}/api/insurances/lojack/Vehicles`, { params }).pipe(
      map((policy) => {
        return policy.map((policy) => ({
          ...policy,
          model: `${policy.brand}-${policy.model}`,
          fullName: `${policy.firstName} ${policy?.lastName}`,
          validity: joinDateRange(policy.startDate?.toString(), policy.endDate?.toString()),
        }));
      })
    );
  }

  public renewVehicle(loJackIds: number[]): Observable<RenewVehicleResponse[]> {
    return this.http.post<RenewVehicleResponse[]>(`${enlineaBackendUrl}/api/insurances/lojack/Vehicles/Renew`, {
      loJackIds,
    });
  }

  public cancelVehicle(loJackIds: number[]): Observable<RenewVehicleResponse[]> {
    return this.http.post<RenewVehicleResponse[]>(`${enlineaBackendUrl}/api/insurances/lojack/Vehicles/Cancel`, {
      loJackIds,
    });
  }

  public getVehicleReport(operationId: number): Observable<Blob> {
    return this.http.get<Blob>(`${enlineaBackendUrl}/api/insurances/lojack/Invoices/report/${operationId}`, {
      responseType: "blob" as "json",
    });
  }
}
